<template>
  <v-container class="main-container">
   <v-row>
      <v-col cols="12">
        <v-card
          tile
          flat
          class="userBriefHistory pl-3"
          :class="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
        >
        <banner-upload-tab></banner-upload-tab>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import BannerUploadTab from '@/components/Partners/BannerUploadTab.vue';
export default {
  components: {
    BannerUploadTab,
  },
};
</script>
